import { faUser, faUnlock, faLock } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import styled from "styled-components"
import { User } from "../../../models/user"
import { FC } from "react"
import { useLeague } from "../../../context/useLeague"
import { useUser } from "../../../context/useUser"

interface Props {
  player: User
  handleShowReleasePlayerModal: (user: User) => void
  showReleasePlayerButton: boolean
  showContractsInfo: boolean
}

const Player: FC<Props> = ({
  player,
  handleShowReleasePlayerModal,
  showReleasePlayerButton,
  showContractsInfo,
}) => {
  const { manager } = useLeague()
  const { user } = useUser()

  const handleClickReleasePlayer = async () => {
    handleShowReleasePlayerModal(player)
  }

  const isManager = manager?._id === player._id
  const isPremium = user?.isPremium
  const canRelease = !isManager && (player.contractOffers[0].seasonsRemaining === 0 || isPremium);

  return (
    <>
      <Wrapper>
        <Container>
          <ImageContainer>
            {/* End contract button */}
            {showReleasePlayerButton &&
              (canRelease ? (
                <CrossContainer onClick={handleClickReleasePlayer}>
                  <IconBackground>
                    <FontAwesomeIcon icon={faUnlock} style={{ color: "red" }} />
                  </IconBackground>
                </CrossContainer>
              ) : (
                <CrossContainer>
                  <IconBackground>
                    <FontAwesomeIcon icon={faLock} style={{ color: "grey" }} />
                  </IconBackground>
                </CrossContainer>
              ))}
            {/* Contract information */}
            {showContractsInfo && !isManager && (
              <ContractInfoContainer className="bg-dark">
                {player.contractOffers[0].seasonsRemaining} seasons <br />{" "}
                remaining
              </ContractInfoContainer>
            )}
            {/* Profile image */}
            {player.profileImage ? (
              <Image image={player.profileImage}></Image>
            ) : (
              <FontAwesomeIcon
                style={{ width: "60%", height: "60%" }}
                icon={faUser}
              />
            )}
          </ImageContainer>
          <InfoContainer>
            <NameContainer>
              <NameText>{player.username}</NameText>
            </NameContainer>
            <PositionContainer>
              <PositionText>{player.position?.toUpperCase()}</PositionText>
            </PositionContainer>
          </InfoContainer>
        </Container>
      </Wrapper>
    </>
  )
}

export default Player

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0.5rem 0;
`
const Container = styled.div`
  aspect-ratio: 1 / 1;
  width: 100%;
  border: 1px solid rgba(63, 113, 195, 1);
  box-shadow: 0px 3px 5px rgba(206, 171, 42, 1);
  padding: 0.2rem;
  font-size: 12px;
  @media (max-width: 480px) {
    font-size: 10px;
  }
  border-radius: 8px;
`
const ImageContainer = styled.div`
  height: 75%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 8px;
`

interface ImageProps {
  image: string
}

const Image = styled.div<ImageProps>`
  background-image: url(${(props) => props.image});
  background-size: cover;
  height: 85%;
  width: 85%;
  margin-top: 0.5rem;
  position: absolute;
  border-radius: 8px;
`

const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 25%;
`
const NameContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
`
const NameText = styled.p`
  padding: 0;
  margin: 0;
  text-align: center;

  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`
const PositionContainer = styled.div`
  height: 100%;
  aspect-ratio: 1/1;
  border: 1px solid rgb(58, 58, 58);
  background-color: #24a9daff;
  box-shadow: 0px 1px 3px rgba(38, 38, 38, 1);
  display: flex;
  justify-content: center;
  border-radius: 8px;
  align-items: center;
`

const PositionText = styled.p`
  margin: 0;
  text-align: center;
  flex: 0 0 auto;
  font-size: 10px;
  border-radius: 8px;
  @media (max-width: 480px) {
    font-size: 9px;
  }
`

const CrossContainer = styled.div`
  padding: 0;
  margin: 0;
  position: absolute;
  height: 25%;
  aspect-ratio: 1/1;
  top: 0;
  right: 0;
  z-index: 2;

  @media (max-width: 960px) {
    height: 20%;
  }
`
const Cross = styled.button`
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
  background-color: #d9534f;
  color: white;
  font-weight: 700;
  cursor: pointer;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ContractInfoContainer = styled.div`
  padding: 0;
  margin: 0;
  position: absolute;
  height: fit-content;
  width: 100%;
  top: 0;
  right: 0;
  z-index: 2;
  border: white 0.5px solid;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`
const IconBackground = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 50%;
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
`
